import React from "react";
import { Tooltip } from "../../ui/Tooltip/Tooltip";
import styles from "./BlockTooltip.module.scss";

export const BlockTooltip = ({ tooltipId, stepsData, className }) => {
  return (
    <div className={styles.blockWithHoveredHint}>
      <Tooltip className={className} stepsData={stepsData} id={tooltipId} />
    </div>
  );
};
